import { NgModule } from "@angular/core";
import { PreloaderComponent } from "./components/preloader.component";
import { CommonModule } from "@angular/common";

@NgModule({
  declarations: [
    PreloaderComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PreloaderComponent
  ],
  providers: []
})

export class SharingModule {

}
